import type { BaseDescriptionListProps } from './types';
import { resolveBaseAppearance } from './theme';
import { cn } from './utils';

const columnClassNames = {
  1: 'grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-2 xl:grid-cols-3',
};

export function BaseDescriptionList({
  items,
  columns = 1,
  appearance,
  className,
  classNames,
  style,
  children,
  ...listProps
}: BaseDescriptionListProps) {
  const theme = resolveBaseAppearance(appearance);

  return (
    <dl
      {...listProps}
      className={cn(
        theme.slots.descriptionListRoot,
        columnClassNames[columns],
        classNames?.root,
        className,
      )}
      style={{
        ...theme.styles.descriptionList,
        ...style,
      }}
    >
      {items?.map((item, index) => (
        <div
          key={index}
          className={cn(theme.slots.descriptionListItem, classNames?.item)}
        >
          <dt className={cn(theme.slots.descriptionListTerm, classNames?.term)}>
            {item.term}
          </dt>
          <dd
            className={cn(theme.slots.descriptionListValue, classNames?.value)}
          >
            {item.value}
          </dd>
        </div>
      ))}
      {children}
    </dl>
  );
}
